import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";

export default defineNuxtRouteMiddleware((_unused_to) => {
  console.debug("userIsGuest middleware");
  const userStore = useUserStore();
  if (userStore.authUserUuid) {
    console.error(`User is already logged in.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Redirecting`,
      body: `Already logged in`,
      appendToast: false,
      position: "top-center",
      variant: "warning",
      solid: true,
    } as ToastItem);
    return navigateTo("/");
  }
});
